<template>
  <TrfModal
    v-if="isAtivo"
    idModal="modal-transferir-tarefa"
    :titulo="titulo"
    btnSaveName="Confirmar"
    :isBtnLoading="isLoading"
    @save="handleConfirmar"
    @close="handleFechar"
    v-e2e="'modal-transferir-tarefa'"
  >
    <div class="column is-9-desktop is-12-mobile">
      <label>Novo departamento</label>
      <Multiselect
        v-model="departamentoSelecionado"
        :options="listaDepartamentos"
        :searchable="true"
        placeholder="Selecione o novo departamento"
        noResultsText="Departamento não encontrado"
        id="select-departamento-transferir"
        class="multiselect-econtador"
        v-e2e="'select-departamento-transferir'"
      />
    </div>
  </TrfModal>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import Multiselect from '@vueform/multiselect';
import { toastUtils } from '../../../util/toast.utils';

export default {
  name: 'TrfModalTransferirTarefa',
  components: {
    TrfModal: defineAsyncComponent(() => import('../index.vue')),
    Multiselect
  },
  props: {
    isAtivo: {
      type: Boolean,
      required: true
    },
    tarefa: {
      type: Object,
      required: true
    },
    listaDepartamentos: {
      type: Array,
      required: true
    },
    titulo: {
      type: String,
      default: 'Transferir departamento'
    }
  },
  emits: ['confirmar', 'fechar'],
  data() {
    return {
      isLoading: false,
      departamentoSelecionado: ''
    };
  },
  methods: {
    handleConfirmar() {
      if (!this.departamentoSelecionado) {
        toastUtils.dangerToast('Selecione um departamento!');
        return;
      }
      
      if (!this.tarefa || !this.tarefa.id) {
        toastUtils.dangerToast('Tarefa inválida!');
        return;
      }
      
      this.isLoading = true;
      this.$emit('confirmar', {
        tarefa: this.tarefa,
        novoDepartamentoId: this.departamentoSelecionado
      });
    },
    handleFechar() {
      this.departamentoSelecionado = '';
      this.isLoading = false;
      this.$emit('fechar');
    }
  },
  watch: {
    isAtivo(novoValor) {
      if (!novoValor) {
        this.departamentoSelecionado = '';
        this.isLoading = false;
      }
    }
  }
};
</script>
